export const shouldISendCmsKeyMissingError = (keyAsArray: string[]): boolean => {
  return !(keyAsArray[0] === '' || keyAsArray.includes('fragments'));
};
